import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../dynamicFormBuilder/FormField'
import { PrimaryLayout } from '../Layout';


function PrimaryTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const finalLayout = useMemo(() => {
        return PrimaryLayout();
    });
    const handleSelectionChange = useCallback((name, value,e) => {
        props.handleFieldChange(name, value,e);
    }, []);

    const handlePrimaryFormLoad = useCallback(() => {
        props.primaryFormLookupsLoad();
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='ae47a236-121c-4caa-a073-798900a3ead5'
                layoutName='AIVectorStoreDataEntryPrimaryForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handlePrimaryFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrimaryTab);
